<div class="dialogContainer">
  <div class="header">
    <h3>Associated Quotes</h3>
  </div>
  @if (quotes) {
    <div class="results">
      <table class="resultsTable">
        <thead>
          <tr>
            <td class="tableCell centeredCell headerCell">Select a quote to apply it to the opportunity</td>
          </tr>
        </thead>
      </table>
      <div class="tableWrapper">
        <table class="resultsTable">
          <thead>
            <tr>
              <td class="tableCell centeredCell headerCell">Quote ID</td>
              <td class="tableCell centeredCell headerCell">Description</td>
              <td class="tableCell centeredCell headerCell">Update Dt</td>
              <td class="tableCell centeredCell headerCell">Channel</td>
              <td class="tableCell centeredCell headerCell">Total Amt</td>
              <td class="tableCell centeredCell headerCell">Qty</td>
              <td class="tableCell centeredCell headerCell">Mult</td>
              <td class="tableCell centeredCell headerCell">Status</td>
              <td class="tableCell centeredCell headerCell">Use As Opp Data</td>
            </tr>
          </thead>
          @for (quote of quotes; track quote) {
            <tr>
              <td class="tableCell">
                <a routerLink="quotes/{{quote.id.entityId}}/{{quote.id.entityRevision}}" target="_blank">
                  {{ quote.id.entityId }}
                </a>
              </td>
              <td class="tableCell">{{ quote.projectName }}</td>
              <td class="tableCell">{{ quote.updateTimestamp | date: 'MM/dd/yyyy':'UTC' }}</td>
              <td class="tableCell">{{ quote.salesChannelCode }}</td>
              <td class="tableCell">{{ quote.totalQuoteAmount | currency:'USD' }}</td>
              <td class="tableCell">{{ quote.unitQuantity }}</td>
              <td class="tableCell">{{ quote.multiplier | number:'1.5-5' }}</td>
              <td class="tableCell">{{ quote.statusDescription }}</td>
              <td class="tableCell">
                <input type="radio" name="radiogroup"
                  (change)="selectAssociatedQuote(quote)">
              </td>
            </tr>
          }
        </table>
      </div>
    </div>
  }
  <div class="buttonRow">
    <span class="spacer"></span>
    <button class="dialogButton primary-button" matButton="elevated" (click)="close()">Go Back</button>
    <button class="dialogButton accent-button" matButton="elevated" (click)="applyQuote()">Apply Quote</button>
  </div>
</div>

